var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2397_14598)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 28,
    r: 16,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.276 22.4008L28.736 31.9407C27.786 32.8907 24.966 33.3307 24.336 32.7007C23.706 32.0707 24.136 29.2507 25.086 28.3007L34.636 18.7508C34.8715 18.4938 35.1566 18.2873 35.4742 18.1436C35.7917 17.9999 36.1351 17.922 36.4836 17.9146C36.832 17.9073 37.1784 17.9706 37.5017 18.1009C37.825 18.2311 38.1186 18.4255 38.3647 18.6723C38.6108 18.9191 38.8044 19.2132 38.9337 19.5368C39.063 19.8605 39.1255 20.207 39.1172 20.5554C39.1089 20.9039 39.03 21.2471 38.8855 21.5642C38.7409 21.8814 38.5336 22.166 38.276 22.4008Z",
    stroke: "#077D65",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 20H23C21.9391 20 20.9218 20.4214 20.1716 21.1716C19.4215 21.9217 19 22.9391 19 24V34C19 35.0609 19.4215 36.0783 20.1716 36.8284C20.9218 37.5786 21.9391 38 23 38H34C36.21 38 37 36.2 37 34V29",
    stroke: "#077D65",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2397_14598",
    x: 0,
    y: 0,
    width: 58,
    height: 58,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2397_14598"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2397_14598",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.449328f0354f66e54dcaabdbe70e8361.svg";
export { ForwardRef as ReactComponent };